module.exports = __webpack_public_path__ + "static/media/12-web-or-mls-DSC06552.70289643.jpg";